import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import piDatePicke from "@/components/pi-date-picke/pi-date-picke.vue";
import i18n from "@/config/i18n";
import { getMerchantSettlement } from "@/api/api-operation-service";
let PiOperDataSettlementData = class PiOperDataSettlementData extends Vue {
    constructor() {
        super(...arguments);
        this.formInline = {
            dateType: "1",
            staPkId: "",
            beginTime: "",
            endTime: "",
        };
        this.settlementData = {};
        this.settlementList = [
            {
                name: i18n.t("operationData.unsettledOrderNum"),
                value: 0,
                icon: "icon-rijiedan",
                iconColor: "iconfont-blue-small",
                key: "unsettledOrderNum",
            },
            {
                name: i18n.t("operationData.notPaidDrawCashOrderNum"),
                value: 0,
                icon: "icon-tixiandan",
                iconColor: "iconfont-blue",
                key: "notPaidDrawCashOrderNum",
            },
            {
                name: i18n.t("operationData.undrawAmount"),
                value: 0,
                icon: "icon-jine-huang",
                iconColor: "iconfont-yellor",
                key: "undrawAmount",
            },
            {
                name: i18n.t("operationData.inPayAmount"),
                value: 0,
                icon: "icon-jine-lan",
                iconColor: "iconfont-blue",
                key: "inPayAmount",
            },
            {
                name: i18n.t("operationData.drawedAmount"),
                value: 0,
                icon: "icon-jine-lv",
                iconColor: "iconfont-green",
                key: "drawedAmount",
            },
            {
                name: i18n.t("operationData.serviceCharges"),
                value: 0,
                icon: "icon-shouxufei",
                iconColor: "iconfont-orange",
                key: "serviceCharges",
            },
        ];
    }
    /**
     * 获取数据
     */
    async getData() {
        const ret = await getMerchantSettlement({});
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data[0] || {};
            this.settlementData = data;
        }
    }
    mounted() {
        this.getData();
    }
};
PiOperDataSettlementData = __decorate([
    Component({
        components: {
            "pi-date-picke": piDatePicke,
        },
    })
], PiOperDataSettlementData);
export default PiOperDataSettlementData;
